import { useTheme } from 'styled-components';
import styled from 'styled-components';
import { EmptyStar } from 'app/ui/components/atoms/icons/star/empty';
import { FilledStar } from 'app/ui/components/atoms/icons/star/filled';

const STAR_VALUES = [1, 2, 3, 4, 5] as const;

interface StarRatingProps {
  value: number | null;
  onChange: (value: number) => void;
  ariaLabel: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: { spacing } }) => spacing(4)};
`;

const StarButton = styled.button`
  background: transparent;
  border: none;
  padding: ${({ theme: { spacing } }) => spacing(1)};
  cursor: pointer;
  border-radius: ${({ theme: { spacing } }) => spacing(1)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.1);
  }

  &:focus-visible {
    outline: 0.125rem solid ${({ theme: { colors } }) => colors.focoltone};
    outline-offset: 0.125rem;
  }
`;

const StarIcon = styled.span`
  display: inline-flex;

  svg {
    width: ${({ theme: { spacing } }) => spacing(8)};
    height: ${({ theme: { spacing } }) => spacing(8)};
  }
`;

export const StarRating = ({ value, onChange, ariaLabel }: StarRatingProps) => {
  const { colors } = useTheme();

  return (
    <Container>
      {STAR_VALUES.map((star) => {
        const isFilled = typeof value === 'number' && star <= value;

        return (
          <StarButton
            key={star}
            type="button"
            aria-pressed={value === star}
            aria-label={`${ariaLabel} ${star}`}
            onClick={() => onChange(star)}
          >
            <StarIcon>
              {isFilled ? <FilledStar color={colors.focoltone} /> : <EmptyStar color={colors.blackSwan} />}
            </StarIcon>
          </StarButton>
        );
      })}
    </Container>
  );
};
